import axios from "axios";
import { BASE_URL } from "../../variables";

export const addDealerLocatorClusterApi = async (zone) => {
  const options = {
    url: `${BASE_URL}/services/apexrest/Get_Cluster/`,
    method: "post",
    data: {
        zone : zone,
    },
  };
  try {
    const response = await axios(options);
    if (response.status === 200) {
      return {
        success: true,
        data: response?.data,
      };
    } else {
      throw Error("Something Went Wrong..!!");
    }
  } catch (err) {
    return {
      success: false,
      msg: "Somthing Went Wrong..!!",
    };
  }
};